import Temp from "@/courier/Temp";
export default class KerryOrangeExpress extends Temp {
  static CODE = "ORNG";
  API_URL = this._VUE.$API_URL;
  static API = {
    checkSameAddress: "/address/province/same",
  };
  static NAMETYPE = {
    BKKG_TO_BKKG: 1,
    BKKG_TO_UPC: 2,
    C_E_W_TO_BKKG: 3,
    C_E_W_TO_ALL: 4,
    C_E_W_SAME_PROVINCE: 5,
    N_NE_S_TO_BKKG: 6,
    N_TO_ALL: 7,
    NE_TO_ALL: 8,
    S_TO_ALL: 9,
    N_SAME_PROVINCE: 10,
    NE_SAME_PROVINCE: 11,
    S_SAME_PROVINCE: 12,
  };
  static NAMEZONE = {
    BKKG: 1,
    C: 2,
    N: 3,
    S: 4,
    E: 5,
    NE: 6,
    W: 7,
  };

  constructor() {
    super(KerryOrangeExpress.CODE);
  }

  async getZone(item) {
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;
    remote_area = super.checkRemoteArea(Number(item.toPostcode));

    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);
    // if (["94", "95", "96"].indexOf(prefixToPostCode) > -1) {
    //   remote_area = this.listPostcodeSpecial[KerryOrangeExpress.CODE].remotearea
    //     .special.cost;
    // }

    if (
      ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
      ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
    ) {
      remote_area = 0;
    }

    from = super.checkZone(item.fromPostcode);
    to = super.checkZone(item.toPostcode);
    if (item.province.to == 'สมุทรสาคร') {
      to = KerryOrangeExpress.NAMEZONE.BKKG;
    }
    if ((item.from.source?item.from.province:item.sameData.province) == 'สมุทรสาคร') {
      from = KerryOrangeExpress.NAMEZONE.BKKG;
    }
    const sameProvince = super.checkSameProviceByName(item);
    type = await this.checkRateType(item, { from: from, to: to });
    let fuel_surcharge_data = await super.getFuelSurcharge();
    const sameProvinceFuelCharge =
      sameProvince || this.checkSameZoneBKKG({ from: from, to: to });
    fuel_surcharge = sameProvinceFuelCharge
      ? fuel_surcharge_data["INPROVINCE"]
      : fuel_surcharge_data["OTHERZONE"];

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      fuel_surcharge: fuel_surcharge,
      cross_price: cross_price,
    };
  }
  async checkRateType(item, zone) {
    if (this.checkSameZoneBKKG(zone))
      return KerryOrangeExpress.NAMETYPE.BKKG_TO_BKKG;
    if (zone.from === KerryOrangeExpress.NAMEZONE.BKKG)
      return KerryOrangeExpress.NAMETYPE.BKKG_TO_UPC;
    const checkSameProvince = await this.checkSameProvinceByZone(zone, item);
    if (checkSameProvince !== false) return checkSameProvince;

    if (
      [
        KerryOrangeExpress.NAMEZONE.C,
        KerryOrangeExpress.NAMEZONE.E,
        KerryOrangeExpress.NAMEZONE.W,
      ].includes(zone.from)
    ) {
      if (zone.to === KerryOrangeExpress.NAMEZONE.BKKG)
        return KerryOrangeExpress.NAMETYPE.C_E_W_TO_BKKG;
      else return KerryOrangeExpress.NAMETYPE.C_E_W_TO_ALL;
    }
    const zoneN_NE_S = [
      KerryOrangeExpress.NAMEZONE.N,
      KerryOrangeExpress.NAMEZONE.NE,
      KerryOrangeExpress.NAMEZONE.S,
    ];
    if (
      zoneN_NE_S.includes(zone.from) &&
      zone.to === KerryOrangeExpress.NAMEZONE.BKKG
    )
      return KerryOrangeExpress.NAMETYPE.N_NE_S_TO_BKKG;

    if (zone.from === KerryOrangeExpress.NAMEZONE.N)
      return KerryOrangeExpress.NAMETYPE.N_TO_ALL;
    if (zone.from === KerryOrangeExpress.NAMEZONE.NE)
      return KerryOrangeExpress.NAMETYPE.NE_TO_ALL;
    if (zone.from === KerryOrangeExpress.NAMEZONE.S)
      return KerryOrangeExpress.NAMETYPE.S_TO_ALL;

    return -1;
  }
  checkSameZoneBKKG(zone) {
    if (
      zone.from === KerryOrangeExpress.NAMEZONE.BKKG &&
      zone.to === KerryOrangeExpress.NAMEZONE.BKKG
    )
      return true;
    else return false;
  }
  async checkSameProvinceByZone(zone, postcodes) {
    if (zone.from !== zone.to) return false;
    const sameProvince = await this.checkSameProvince(postcodes);
    if (!sameProvince) return false;

    if (
      zone.from === KerryOrangeExpress.NAMEZONE.C ||
      zone.from === KerryOrangeExpress.NAMEZONE.E ||
      zone.from === KerryOrangeExpress.NAMEZONE.W
    )
      return KerryOrangeExpress.NAMETYPE.C_E_W_SAME_PROVINCE;

    if (zone.from === KerryOrangeExpress.NAMEZONE.N)
      return KerryOrangeExpress.NAMETYPE.N_SAME_PROVINCE;

    if (zone.from === KerryOrangeExpress.NAMEZONE.S)
      return KerryOrangeExpress.NAMETYPE.S_SAME_PROVINCE;

    if (zone.from === KerryOrangeExpress.NAMEZONE.NE)
      return KerryOrangeExpress.NAMETYPE.NE_SAME_PROVINCE;

    return false;
    // let zones = {
    //     'C_E': this.checkSameZoneC_E,
    //     'N': this.checkSameZoneN,
    //     'S': this.checkSameZoneS,
    //     'NE': this.checkSameZoneNE
    // }
    // if( zones[nameZone](zone) === true )return true
    // else return false
  }
  async checkSameProvince(item) {
    return (
      (!item.source && item.province.sameData == item.province.to) ||
      (item.source && item.province.from == item.province.to)
    );
    // const check = await this._VUE.$http.get(
    //   this.API_URL + KerryOrangeExpress.API.checkSameAddress,
    //   {
    //     headers: {
    //       Token: localStorage.getItem("access_token"),
    //     },
    //     params: {
    //       from_postcode: item.fromPostcode,
    //       to_postcode: item.toPostcode,
    //     },
    //   }
    // );

    // try {
    //   const _check = check.data.data;
    //   if (_check.status === false) throw _check.msg;
    //   else if (_check.msg === "not within same province") return false;
    //   else return true;
    // } catch (err) {
    //   console.info(err);
    //   return false;
    // }
  }
  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    return super.checkRules(item, validate);
  }
  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }
  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["ORNG"]).then((res) => {
        resolve({
          isRemote: res.data.ORNG.is_remote?50:0
        });
      });
    });
  }
}
